import { Router } from "@frui.ts/screens";
import { attachAutomaticValidator } from "@frui.ts/validation";
import { Modules, newNavigationName } from "config";
import CreateCountryRequest, { CountryValidationRules } from "entities/createCountryRequest";
import EnumRepository from "repositories/enumRepository";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import CountryResponse from "entities/countryResponse";
import CreateViewModel from "viewModels/createViewModel";

@Router.registerRoute({ route: newNavigationName, name: Router.Self })
export default class CountryCreateViewModel extends CreateViewModel<CreateCountryRequest> {
  readonly modelName = "country";

  constructor(
    protected localizationService: LocalizationService,
    protected repository: EnumRepository,
    protected notificationService: NotificationService,
    protected eventBus: EventBus
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  protected postData() {
    return this.repository.create(this.item, "countries", CountryResponse, "1.2");
  }

  protected loadDetail() {
    const item = new CreateCountryRequest();

    attachAutomaticValidator(item, CountryValidationRules);
    return item;
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.timeCharges, `countries.${code}`);
  }
}
